import { useEffect, useState } from "react";
import { Button } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import StudentTable from "../Dashboard/StudentTable";
import classRoomImg from "../../../../assets/img/teacherDashboard/Classroom.png";
import BackButton from "../Goback/GoBack";
import { useActivateExistingStudents } from "../../../../hooks/school/assing-license/useActivateExistingStudents";
import { useActivateStudents } from "../../../../hooks/school/assing-license/useActivateStudents";
import DeleteModal from "../../../common/DeleteModal";
import RoleGuard from "../../../auth/RoleGuard";

const Student = () => {
    const navigate = useNavigate();

    const {
        data: activateData,
        loading: activateCheckLoading,
        error: activateCheckError,
        getActivateExistingStudents,
    } = useActivateExistingStudents();

    const {
        loading: activating,
        error: activateError,
        success: activateSuccess,
        message: activateMessage,
        activateStudents,
    } = useActivateStudents();

    const [showActivateModal, setShowActivateModal] = useState(false);
    // Key to force-remount StudentTable after successful activation (to refresh data)
    const [tableKey, setTableKey] = useState(0);

    const canActivate = activateData?.can_activate > 0;

    useEffect(() => {
        getActivateExistingStudents();
    }, []);

    const handleActivateClick = () => {
        setShowActivateModal(true);
    };

    const handleActivateClose = () => {
        setShowActivateModal(false);
    };

    const handleActivateConfirm = async () => {
        await activateStudents(() => {
            getActivateExistingStudents();
            // Force remount table to refresh student data after activation
            setTableKey((k) => k + 1);
        });
    };

    return (
        <>
            <div className="classroom-cnt">
                <div className="classroom-container">
                    <img src={classRoomImg} className="img" alt="Classroom" />
                    <h2 className="text">Manage Student(s)</h2>
                </div>

                <div className="btn-container d-flex gap-2">
                    <RoleGuard permission="dashboard_assign_licenses">
                        <Button
                            className="primary-btn"
                            disabled={activateCheckLoading || !canActivate}
                            onClick={handleActivateClick}
                            title={
                                activateCheckLoading
                                    ? "Checking..."
                                    : canActivate
                                        ? `Activate ${activateData.can_activate} student(s)`
                                        : activateCheckError
                                            ? "Failed to check activation status"
                                            : "No students available to activate"
                            }
                        >
                            {activateCheckLoading
                                ? "Checking..."
                                : `Assign Licenses${canActivate ? ` (${activateData.can_activate})` : ""}`}
                        </Button>
                    </RoleGuard>

                    <Button
                        className="primary-btn"
                        onClick={() => {
                            navigate("/teacher/student/create");
                        }}
                    >
                        Add Student
                    </Button>
                </div>

                <div>
                    <StudentTable key={tableKey} />
                </div>
            </div>

            <DeleteModal
                showModal={showActivateModal}
                handleClose={handleActivateClose}
                handleDelete={handleActivateConfirm}
                message={`Are you sure you want to activate ${activateData?.can_activate || 0} student(s)? This will assign available licenses to inactive students.`}
                loading={activating}
                error={activateError}
                success={activateSuccess}
                successMessage={activateMessage || "Students activated successfully."}
                onSuccessContinue={handleActivateClose}
                customSuccessTitle="Activation Successful"
                customErrorTitle="Activation Failed"
                customConfirmTitle="Confirm Activation"
                customActionButtonText="Activate"
                customLoadingButtonText="Activating..."
            />
        </>
    );
};

export default Student;